import { normalizeBoolean } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_USE_MEMBERSHIP_DONATION_LANGUAGE = createFcmConfig('use_membership_donation_language', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
